import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Actions from '../../actions';
import APP_ACTIONS from '../../constants/app-actions';
import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import APP_ROUTES from '../../constants/app-routes';
import PaymentRedsysForm from '../../components/checkout-steps/payment-redsys-form';

const mapStateToProps = (state, ownProps) => ({
    order: state.order,
    placedOrder: state.placedOrder,
    locale: state.locale,
    stores: state.stores.stores,
    displayLoader: state.displayLoader,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentCheckoutStep: () => {
        dispatch({
            type: APP_ACTIONS.SET_CURRENT_CHECKOUT_STEP,
            payload: 'payment',
        });
    },

    handlePaymentFormSubmit: (formData, order, locale) => dispatch(Actions.goToNextStep(order, locale, formData)),
    handlePaymentBackStep: (order, locale) => dispatch(Actions.goToPrevStep(order, locale, 'payment')),

    handleCheckoutStepNotEditable: (order, placedOrder) => {
        /* Redirect to last step if order is already placed */
        if (placedOrder.id) {
            dispatch(push(APP_ROUTES.checkout[`${placedOrder.checkout_steps.slice(-1)}PageRoute`]));
        } else if (order.id) {
            const previousStep = CheckoutStepCalculator.previous(order.checkout_steps, 'payment');

            dispatch(push(APP_ROUTES.checkout[`${previousStep}PageRoute`]));
        } else {
            dispatch(push(APP_ROUTES.cartPageRoute));
        }
    },

    redirectToCart: () => dispatch(push(APP_ROUTES.cartPageRoute)),

    showFormErrors: (errorNode) => {
        // dispatch(Actions.showFlash(errorNode, 'danger'));
    },

    getRedsysInfo: () => dispatch(Actions.getRedsysInfo()),

    addRedsysPaymentError: (error) => {
        dispatch(Actions.addRedsysPaymentError(error));
    },
});

const PaymentRedsysFormConnector = connect(mapStateToProps, mapDispatchToProps)(PaymentRedsysForm);

export default PaymentRedsysFormConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/payment-redsys-form-connector.js
 **/